import React from 'react'

function CloudComputing() {
  return (
    <div>
        <div className="container mx-auto px-4 py-24">
      <div className="bg-white shadow-lg rounded-lg p-8">
        <h1 className="text-3xl font-bold text-center mb-4">Unlock the Power of Cloud Computing: Transform Your Career!</h1>
        <p className="text-lg text-gray-700 mb-6">
          Are you ready to leverage the flexibility, scalability, and cost-effectiveness of Cloud Computing? Join our Cloud Computing program and become an expert in designing, deploying, and managing cloud-based systems.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Why Cloud Computing?</h2>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>High demand: Cloud professionals are in high demand across industries.</li>
          <li>Career growth: Enhance your skills and advance your career.</li>
          <li>Competitive salary: Cloud experts earn attractive salaries.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Our Cloud Computing Program</h2>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>Comprehensive curriculum: Covering cloud fundamentals, architecture, security, and more.</li>
          <li>Hands-on training: Practical experience with industry-standard platforms (AWS, Azure, Google Cloud).</li>
          <li>Expert instructors: Guided learning from experienced cloud professionals.</li>
          <li>Real-world projects: Apply cloud concepts to real-world scenarios.</li>
          <li>Certification support: Prepare for industry-recognized certifications.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Cloud Computing Training Roadmap</h2>

        <h3 className="text-xl font-semibold text-gray-800 mb-2">Level 1: Cloud Foundations (2 weeks)</h3>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>Introduction to Cloud Computing</li>
          <li>Cloud Service Models (IaaS, PaaS, SaaS)</li>
          <li>Cloud Deployment Models (Public, Private, Hybrid)</li>
          <li>Cloud Security Fundamentals</li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-800 mb-2">Level 2: Cloud Architecture (4 weeks)</h3>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>Cloud Architecture Design</li>
          <li>Scalability and Performance</li>
          <li>Cloud Storage and Database</li>
          <li>Cloud Networking and Security</li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-800 mb-2">Level 3: Cloud Platforms (8 weeks)</h3>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>Amazon Web Services (AWS)</li>
          <li>Microsoft Azure</li>
          <li>Google Cloud Platform (GCP)</li>
          <li>Cloud Migration and Deployment</li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-800 mb-2">Level 4: Advanced Cloud (4 weeks)</h3>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>Cloud Automation (Terraform, CloudFormation)</li>
          <li>Cloud Security and Compliance</li>
          <li>Cloud Analytics and Machine Learning</li>
          <li>Emerging Trends (Serverless, Edge Computing)</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Certifications</h2>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>AWS Certified Cloud Practitioner</li>
          <li>Microsoft Certified: Azure Developer Associate</li>
          <li>Google Cloud Certified - Professional Cloud Developer</li>
          <li>CompTIA Cloud+</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Career Paths</h2>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>Cloud Architect</li>
          <li>Cloud Engineer</li>
          <li>Cloud Security Specialist</li>
          <li>Cloud Migration Specialist</li>
          <li>Cloud Consultant</li>
        </ul>

        <div className="mt-8 text-center">
          <p className="text-lg font-semibold text-gray-800">Join Our Cloud Computing Program Today!</p>
          <p className="text-gray-700 mb-2">Don't miss out on this opportunity to transform your career. Contact us to learn more.</p>
          <p className="text-gray-700">
            <strong>Email:</strong> cloudcomputing@techeraafrica.com <br />
            <strong>Phone:</strong> 080 2263 2222
          </p>
          <a
            href="/brochure"
            className="mt-4 inline-block bg-blue-600 text-white font-semibold py-2 px-6 rounded-md shadow hover:bg-blue-700"
          >
            Download Our Brochure
          </a>
        </div>
      </div>
    </div>
    </div>
  )
}

export default CloudComputing